module.exports = __webpack_public_path__ + "img/26.c24e3803.png";